import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { TooltipModule } from 'primeng/tooltip';
import { ReleaseNotesComponent } from './release-notes.component';

@NgModule({
  declarations: [ReleaseNotesComponent],
  imports: [CommonModule, ButtonModule, RippleModule, TooltipModule],
  exports: [ReleaseNotesComponent],
})
export class ReleaseNotesModule {}
